import React from "react";
import { Link } from "react-router-dom";
import { app } from './firebaseconfig'
import Header1 from './Header'
import './assets/css/main.css'
import SignUp from "./SignUp";
import ReactDOM from 'react-dom';
import ExampleComponent from "react-rounded-image";
import Footer from "./Footer"


class privacypolicy extends React.Component{

    refreshPage = () => {
        window.location.reload(true);
      }
    
   logout = () => {
        app.auth().signOut().then(function() {
            window.location.reload(false);
          }).catch(function(error) {
            console.log(error)
          });
    } 

    loggedin = () => {
        app.auth().onAuthStateChanged(function(user) {
            if (user) {
              return true
            } else {
              return false
            }
        });
    }
//onClick={logout}
//{app.auth().currentUser ? (<h4>Welcome to the MainPage</h4> ) : (<h4>You need to login to upload docs</h4>)}<br></br>
//<h3>Welcome to the MainPage</h3><br></br>
          //  { app.auth().currentUser ? (<h4>You are logged in</h4> ) : (<h4>You need to login to upload docs</h4>)}<br></br>
           // <Link to="/Upload_Your_Documents"> Click to upload your documents</Link><br></br>
           // <Link to="/Documents"> Documents</Link><br></br>
           // <Link to="/Login"> Login</Link><br></br>
           // <Link to="/Signup"> Signup</Link><br></br>
           // <button  onClick={this.logout}> Logout</button>
render(){
    return (
      <>

<head>
		<title>UOB Notes</title>
		<meta charset="utf-8" />
		<meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=no" />
		<link rel="stylesheet" href="assets/css/main.css" />
	</head>
	<body className="landing is-preload">
		<div id="page-wrapper">

			
        <section id="cta2" className="container">
      <Header1></Header1>
      </section>
 
<br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>

				<section id="main" className="container">
                <p><center><h2><b>'UOB Notes' Privacy Policy</b></h2></center><br/>
 
                
 
                We are committed to protect your privacy; as a result; Google explicitly stores your email address and encrypted password. www.uobnotes.com can only view your registered email address, but not your password. 
If you have any questions about your personal information please < a href="/contactus">contact us</a>.

 <br/><br></br><center><b>How Your Personal Information is Used</b></center><br/>
 We might use your personal information to:<br></br>
 <ul>
<li>Make you a registered member on our website/platform, in order for you to contribute, share and upload content.</li>
<li>Inform you of activity on our site by using your email address.</li>
<li>Communicate with you about newsletters, announcements and other information. Registered users could opt-in to or opt-out of such emails.</li> 
<li>Track the numbers of visitors to our website/platform </li></ul>

 <center><b>Data Security</b></center><br/>
 We are dedicated to ensure that your information is held securely. This is why we store your email address and encrypted password with Google. www.uobnotes.com can only view your registered email address, while passwords can neither be viewed by Google nor by www.uobnotes.com.

  
 <br/><br></br><center> <b>Cookie Policy</b></center><br/>

 Cookies are small content documents which are set by us on your device which permits us to give certain functionality on our website/platform. For example, this is applicable in the event of remembering certain preferences or logging in.

 <br/><br></br><center><b>Rights</b></center><br/>
 You are entitled to obtain a copy of the personal data we collected from you. In order to request a copy, please < a href="/contactus">contact us</a>. Upon the desire of the registered user, we could erase and terminate all data we have about you. If you would like to remove your data, please < a href="/contactus">contact us</a>. 

 <br/><br></br><center><b>  Acceptance of This Policy </b></center><br/>
 By registering as a user in the website/platform, you directly indicate that you fully agree to this policy. If you do not understand the policy, or do not accept any part of it, then you may not use the website/platform. 

 <br/><br></br><center><b>Changes to This policy</b> </center><br/>
 We could amend this policy at any time. However, before the new changes go into effect, we may provide prior notice to our registered users.

 
 
</p>						
				</section>

		

			
				<Footer></Footer>

		</div>

		
			<script src="assets/js/jquery.min.js"></script>
			<script src="assets/js/jquery.dropotron.min.js"></script>
			<script src="assets/js/jquery.scrollex.min.js"></script>
			<script src="assets/js/browser.min.js"></script>
			<script src="assets/js/breakpoints.min.js"></script>
			<script src="assets/js/util.js"></script>
			<script src="assets/js/main.js"></script>

	</body>
          </>
    );
};
}
export default privacypolicy;